<app-modal
  #modal
  (isDismissing)="closeModal()"
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    showFooter: false,
    titleText: 'Previewing Topic Competencies',
    options: {
      size: 'xl',
    }
  }">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div *ngIf="topic" class="form-content xpy-3 xpx-1">
    <ng-container *ngIf="!isLoading && competencies; else loadingTemplate">
      <ul>
        <ng-container *ngFor="let competency of competencies">
          <app-onboarding-competency
            [topicId]="topic.id"
            [compId]="competency.id" />
        </ng-container>
      </ul>
    </ng-container>
    <ng-template #loadingTemplate>
      <div
        class="w-100 position-relative"
        style="background-color: #fff; height: 500px">
        <app-loader></app-loader>
      </div>
    </ng-template>
  </div>
</app-modal>
